import React, {Component} from 'react'
import {withNamespaces} from 'react-i18next'
import withStyles from '@mui/styles/withStyles'
import {assign, find, flowRight as compose, get} from 'lodash'
import {ACCOUNTS_QUERY, PROMO_MATERIALS_QUERY} from '../../../graphql/queries'
import {promoMaterialTypes} from '@bdswiss/common-enums'
import {graphql, withApollo} from 'react-apollo'
import {isIntroducingBrokerAccount} from '../../../common/utils'
import PromoMaterialLayout from './PromoMaterialLayout'

const styles = theme => ({})
class Banners extends Component {
  render() {
    const {promoMaterials, account, fetchMore, promoMaterialsCount, refetchPromoMaterials} = this.props
    return (
      <PromoMaterialLayout
        promoMaterials={promoMaterials}
        account={account}
        fetchMore={fetchMore}
        promoMaterialsCount = {promoMaterialsCount}
        type={promoMaterialTypes.banner.key}
        filterIds={[{id: 'size'}, {id: 'campaign'}, {id: 'language'}]}
        innerFilterIds={[{id: 'language'}, {id: 'size'}, {id: 'ibId'}]}
        refetchPromoMaterials={refetchPromoMaterials}
      />
    )
  }
}

export default compose(
  withStyles(styles, {withTheme: true}),
  withNamespaces(),
  withApollo,
  graphql(ACCOUNTS_QUERY, {
    options: () => ({fetchPolicy: 'network-only'}),
    props: ({data: {error, loading}, data}) => ({
      error,
      loading,
      account: find(get(data, 'viewer.accounts'), (a) => isIntroducingBrokerAccount(a)),
    })
  }),
  graphql(PROMO_MATERIALS_QUERY, {
    name: 'fetchPromoMaterials',
    options: () => ({
      fetchPolicy: 'network-only',
      variables: {
        type: promoMaterialTypes.banner.key,
        uniqueAssetName: true,
        limit: 5,
        offset: 0,
      }
    }),
    props: ({fetchPromoMaterials:{error, loading, promoMaterials, promoMaterialsCount, refetch, fetchMore}}) => ({
      loading,
      error,
      promoMaterials,
      promoMaterialsCount,
      refetchPromoMaterials: refetch,
      fetchMore: (variables) => fetchMore({
        variables,
        updateQuery: (prev, {variables, fetchMoreResult}) => {
          const {promoMaterials:prevPromoMaterials} = prev
          const {promoMaterials:nextPromoMaterials} = fetchMoreResult
          if (!fetchMoreResult || prevPromoMaterials?.length > variables?.offset) return prev
          return assign({}, prev, {promoMaterials: [...prevPromoMaterials, ...nextPromoMaterials]})
        }
      })
    }),
  }),
)(Banners)
